import _ from "lodash";
import { path } from "../../api";
import * as actions from "../../utils/actions";
import { restClient } from "../../utils/restClient";

const initialState = {
  birthdayPromotion: null,
};

export default {
  namespaced: true,
  name: "birthdayPromotions",
  state: _.cloneDeep(initialState),
  mutations: {
    [actions.GET_BIRTHDAY_PROMOTION_CONFIG](state, payload = null) {
      state.birthdayPromotion = payload;
    },
    [actions.SAVE_BIRTHDAY_PROMOTION_CONFIG](state, payload = null) {
      state.birthdayPromotion = payload;
    },
    [actions.RESET_BIRTHDAY_PROMOTION_FORM](state) {
      state.birthdayPromotion = null;
    },
  },
  actions: {
    async fetchBirthdayConfig({ commit }) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.birthdayPromotions.base,
            "GET"
          );
          commit(actions.GET_BIRTHDAY_PROMOTION_CONFIG, response?.data);
          resolve(response?.data);
        } catch (error) {
          commit(actions.GET_BIRTHDAY_PROMOTION_CONFIG, null);
          reject(error);
        }
      });
    },
    async saveBirthdayConfig({ commit }, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.birthdayPromotions.base,
            "PUT",
            payload
          );
          commit(actions.SAVE_BIRTHDAY_PROMOTION_CONFIG, response?.data);
          resolve(response.data);
        } catch (error) {
          reject(error);
        }
      });
    },
    resetForm({ commit }) {
      commit(actions.RESET_BIRTHDAY_PROMOTION_FORM);
    },
  },
};
